export const routeConfigError = (message: string) =>
  createError({
    statusCode: 500,
    statusMessage: 'Route Configuration Error',
    message,
  });
